import { store as secureStorage } from './SecureLS'

const SESSION_KEYS = ['shppr:sso:atk[stock]', 'shppr:sso:cck:home:list_receivement[stock]', 'shppr:sso:cck:home:receivement[stock]', 'shppr:sso:rtk[stock]', 'shppr:sso:u[stock]']

export const clearPersistedSession = ({ preserveLocalStorage = true } = {}) => {
  if (preserveLocalStorage) {
    SESSION_KEYS.forEach((key) => localStorage.removeItem(key))
  } else {
    secureStorage.clear()
    localStorage.clear()
  }
}